var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtremeConsumption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.67 60.62C85.67 55.84 84.42 52.07 83.41 49.87C80.61 43.38 75.4 38.18 68.89 35.34C68.86 35.31 68.81 35.29 68.76 35.26C56.72 29.86 43.72 33.43 36.31 42.74H36.33C32.1 47.7 29.56 54.15 29.59 61.23C29.61 65.12 30.41 68.82 31.85 72.16C31.9 72.3 31.95 72.43 32.01 72.58C33.34 75.79 35.07 78.02 36.35 79.35C38.37 81.69 40.78 83.69 43.49 85.26C48.82 88.65 54.73 89.86 61.13 88.88C65.3 88.39 69.18 86.97 72.57 84.83C77.26 82.03 80.76 78.06 83 72.99C84.75 69.26 85.71 65.07 85.68 60.65V60.63L85.67 60.62Z",
    fill: "#FF4F40",
    stroke: "#FF4F40",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.44 70.33L59.66 41.27C58.76 39.71 56.5 39.71 55.6 41.27L38.82 70.33C37.92 71.89 39.05 73.85 40.85 73.85H74.41C76.22 73.85 77.34 71.9 76.44 70.33Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.81 6.60998C51.93 6.39998 51.65 6.19998 51.48 6.35998L17.69 40.24H17.65L9.42001 48.55H24.43L5.89001 82.07C5.77001 82.28 6.05001 82.48 6.22001 82.32L39.9 48.55H39.93L48.16 40.24H33.2L51.81 6.60998Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3 30.66L17.18 45.82H31.71L24.98 57.99C24.98 57.99 24.99 58.03 25.01 58.01L40.09 42.89H25.58L32.33 30.68C32.33 30.68 32.32 30.64 32.3 30.66Z",
    fill: "#FF931E",
    stroke: "#FF931E",
    strokeWidth: 1.11,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.53 65.95C55.64 65.67 55.8 65.43 56.01 65.22C56.22 65.01 56.46 64.85 56.74 64.74C57.02 64.62 57.32 64.57 57.63 64.57C57.94 64.57 58.24 64.63 58.52 64.74C58.8 64.85 59.04 65.02 59.25 65.22C59.45 65.43 59.62 65.67 59.73 65.95C59.85 66.23 59.9 66.53 59.9 66.84C59.9 67.15 59.84 67.45 59.73 67.73C59.61 68.01 59.45 68.25 59.25 68.46C59.04 68.67 58.8 68.83 58.52 68.94C58.24 69.06 57.94 69.11 57.63 69.11C57.32 69.11 57.02 69.05 56.74 68.94C56.46 68.82 56.22 68.66 56.01 68.46C55.8 68.25 55.64 68.01 55.53 67.73C55.41 67.45 55.36 67.15 55.36 66.84C55.36 66.53 55.42 66.23 55.53 65.95ZM59.83 51.16L59.16 62.17H56.05L55.38 51.16H59.82H59.83Z",
    fill: "#FF4F40",
    stroke: "#FF4F40",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtremeConsumption);
export default __webpack_public_path__ + "static/media/extreme-consumption.338cbc0309102f8c1703dc65330d4be9.svg";
export { ForwardRef as ReactComponent };